//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";

import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    }
});

class PredefinedMessageDetails extends Component {
    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);


        this.state = {
            accordion: [false, false, false],
        };

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: new Array(4).fill('1'),
        };
    }

    lorem() {
        return 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.'
    }

    toggle(tabPane, tab) {
        const newArray = this.state.activeTab.slice()
        newArray[tabPane] = tab
        this.setState({
            activeTab: newArray,
        });
    }

    tabPane() {
        return (
            <>
                <TabPane tabId="1">
                    {`1. ${this.lorem()}`}
                </TabPane>
                <TabPane tabId="2">
                    {`2. ${this.lorem()}`}
                </TabPane>
                <TabPane tabId="3">
                    {`3. ${this.lorem()}`}
                </TabPane>
            </>
        );
    }

    toggleAccordion(tab) {

        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);

        this.setState({
            accordion: state,
        });
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_PRE_MESSAGES}
                                </li>
                                <li style={{ paddingLeft: "720px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <div>
                                    <div className="h3CustomeHeading">{siteConstants.MENU_PRE_MESSAGES}</div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" md="12" className="mb-4">
                                                            <Nav tabs>
                                                                <NavItem>
                                                                    <NavLink
                                                                        active={this.state.activeTab[0] === '1'}
                                                                        onClick={() => { this.toggle(0, '1'); }}
                                                                    >
                                                                        Email
                                                                </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        active={this.state.activeTab[0] === '2'}
                                                                        onClick={() => { this.toggle(0, '2'); }}
                                                                    >
                                                                        SMS
                                                                </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        active={this.state.activeTab[0] === '3'}
                                                                        onClick={() => { this.toggle(0, '3'); }}
                                                                    >
                                                                        Push
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                            <TabContent activeTab={this.state.activeTab[0]}>
                                                                {this.tabPane()}
                                                            </TabContent>
                                                        </Col>


                                                    </Row>
                                                </CardBody>
                                                <CardFooter>
                                                    <button className="btn btn-payment-paid">{siteConstants.LABEL_PAYMENT_PAID}</button>
                                                </CardFooter>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">

                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card>
                                                <CardHeader>

                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <strong>Instructions</strong>
                                                        </div>
                                                    </div>
                                                </CardHeader>
                                                <CardBody>
                                                    No
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language } = state;
    return {
        language,
    };
}
const connectedMembership = connect(mapStateToProps)(withStyles(styles)(PredefinedMessageDetails));
export { connectedMembership as PredefinedMessageDetails };